var _path, _g, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoTimer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 80,
    viewBox: "0 0 98 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2087_867)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2087_867",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 60,
    y: 42,
    width: 35,
    height: 35
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.5195 42.572L77.7192 42.5737C86.9521 42.7311 94.4089 50.1802 94.5682 59.4125L94.5708 59.7141L94.5682 60.0126C94.4106 69.2453 86.9549 76.6954 77.7224 76.8545L77.4208 76.8571L77.1223 76.8546C67.7886 76.6954 60.2865 69.0853 60.2865 59.7141C60.2865 50.2766 67.8952 42.6251 77.3208 42.5714L77.5195 42.572ZM77.4295 45.9999L77.1529 46.0026C69.703 46.1498 63.7153 52.2297 63.7153 59.7141C63.7153 67.1986 69.703 73.2784 77.1529 73.4256L77.4295 73.4283L77.706 73.4256C85.0611 73.2803 90.9929 67.3497 91.14 59.9941L91.1428 59.7141L91.1401 59.4376C90.9929 51.9885 84.9131 45.9999 77.4295 45.9999ZM78.6985 50.8253V59.7141L86.3182 64.4758L84.4129 67.3329L75.5241 61.6186V50.8253H78.6985Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2087_867)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.1121 80.0312H97.7461V39.3972H57.1121V80.0312Z",
    fill: "#B8B8B8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.9376 83.2052H100.92V36.2223H53.9376V83.2052Z",
    fill: "#B8B8B8"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2857 72.5714H12C9.79086 72.5714 8 70.7805 8 68.5714V9.71423C8 7.50509 9.79086 5.71423 12 5.71423H86.2857C88.4948 5.71423 90.2857 7.50509 90.2857 9.71423V37.2142",
    stroke: "#B8B8B8",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49.1429 61.8571C49.9713 61.8571 50.6429 61.1855 50.6429 60.3571C50.6429 59.5286 49.9713 58.8571 49.1429 58.8571V61.8571ZM8 61.8571H49.1429V58.8571H8V61.8571Z",
    fill: "#B8B8B8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7858 49.4852V19.901L64.0829 35.2848L37.7858 49.4852ZM64.8504 35.7338C64.85 35.7336 64.8496 35.7333 64.8493 35.7331L64.8504 35.7338Z",
    stroke: "#B8B8B8",
    strokeWidth: 3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2087_867"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 98,
    height: 80,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoTimer);
export default __webpack_public_path__ + "static/media/video-timer.175943f3268a0d82c9cf1414393262bd.svg";
export { ForwardRef as ReactComponent };